import { render } from "./WhiteboardCanvas.vue?vue&type=template&id=61ec2137"
import script from "./WhiteboardCanvas.vue?vue&type=script&lang=js"
export * from "./WhiteboardCanvas.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__